import { getUrl } from 'aws-amplify/storage';

const GetHeroVideo = async () => {
    try {
        const downloadResult = await getUrl({
            path: 'public/v3.mp4',
            // Alternatively, path: ({identityId}) => `protected/${identityId}/album/2024/1.jpg`
        });
        const text = await downloadResult.url;
        // console.log('All files:', filteredBodies);
        return text
    } catch (error) {
        console.error('Error fetching file URLs:', error);
        return [];
    }
};

export default GetHeroVideo;